import { of } from "rxjs";
import { Injectable } from "@angular/core";
import type { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { NodeSharedFacade } from '@medsurf/flat-facades';
import { validate } from "uuid";

@Injectable({
  providedIn: "root"
})
export class SlideSharedResolver implements Resolve<void> {
  constructor(protected nodeSharedFacade: NodeSharedFacade) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const idSlug = route.paramMap.get('idSlug');

    const uuid = idSlug ?? '';
    if (validate(uuid)) {
      return this.nodeSharedFacade.requestGetSlideDataByPageId(uuid);
    }

    const id = parseInt(idSlug ?? '', 10);
    if (!isNaN(id)) {
      return this.nodeSharedFacade.requestGetSlideDataBySlideId(id);
    }

    return of([]);
  }
}